export default {
  version: '1.45.2', // Текущая версия приложения
  forceUpdate: false
};
